import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { sendEmailVerification } from "firebase/auth";
import { auth } from "@/lib/firebase/firebase";
import { WarningCircleIcon } from "@phosphor-icons/react";

export function EmailVerificationBanner() {
  const { user } = useAuth();
  const [isSending, setIsSending] = useState(false);

  // Ha a felhasználó nincs bejelentkezve vagy már megerősítette az email címét, ne jelenítse meg a bannert
  if (!user || user.emailVerified) {
    return null;
  }

  const handleResendVerification = async () => {
    setIsSending(true);
    try {
      const currentUser = auth.currentUser;
      if (currentUser) {
        // Email megerősítés alapértelmezett beállításokkal
        await sendEmailVerification(currentUser);
        toast.success("Megerősítő email elküldve", {
          description: "Kérjük, ellenőrizd a beérkező leveleidet (és a spam mappát is)."
        });
      }
    } catch (error: unknown) {
      console.error("Error sending verification email:", error);
      
      // Túl sok kérés hiba kezelése
      if (error && typeof error === 'object' && 'code' in error && error.code === 'auth/too-many-requests') {
        toast.error("Túl sok kérés. Kérjük, próbáld újra később.", {
          description: "A megerősítő emailek küldése korlátozva van."
        });
      } else {
        const errorMessage = error instanceof Error ? error.message : "Kérjük, próbáld újra később.";
        toast.error("Hiba történt a megerősítő email küldése során", {
          description: errorMessage
        });
      }
    } finally {
      setIsSending(false);
    }
  };

  return (
    <Alert className="mb-4">
      <WarningCircleIcon />
      <AlertTitle>Email cím megerősítése szükséges</AlertTitle>
      <AlertDescription>
        A fiókod létrehozásakor küldtünk egy megerősítő emailt a(z) <strong>{user.email}</strong>{" "}
        címre. Kattints a benne található linkre a fiókod aktiválásához. Ha nem találod,
        ellenőrizd a spam mappát is.
      </AlertDescription>
      {/* A gomb a leírás UTÁN áll, nem benne: az `AlertDescription` `text-muted-foreground`-ja
          különben a gomb feliratát is elhalványítaná (az `outline` variáns nem hoz saját
          szövegszínt). A `col-start-2` az ikon melletti oszlopba teszi, a leírással egy
          vonalba. Nem `AlertAction`: a jobb felső sarok csak ~72px-et tart fenn, ennél a
          feliratnál 390px-en a szövegre csúszna. */}
      <div className="col-start-2 mt-3">
        <Button
          variant="outline"
          size="sm"
          onClick={handleResendVerification}
          loading={isSending}
        >
          {isSending ? "Küldés..." : "Megerősítő email újraküldése"}
        </Button>
      </div>
    </Alert>
  );
}
